export const Loading = () => {
  return (
    <div className='loadingPanel' role="status" aria-live="polite" aria-label="Loading">
      <div className="lds-ripple" aria-hidden="true"><div></div><div></div></div>
      <span className="sr-only">Loading</span>
    </div>
  )
}
